import { Alert } from "antd";
import React from "react";
import { useLoaderData } from 'react-router-dom';
import styles from './onhold.module.scss';
const Onhold = () => {
    const { productionDetails } = useLoaderData()
    return <div className={styles.container}>
        <h3>Task For You</h3>
        <Alert message='The order is on hold' description={`Reason : ${productionDetails.comments.hold_reason ?? 'N/A'}`} />
    </div>
}
export default Onhold;